<template>
    <div class="list-no-data">{{title}}</div>
</template>
<style scoped>
  .list-no-data{
    padding-top:45px;
    color: #666;
    font-size: 16px;
    text-align: center;
  }
  @media (max-width: 650px){
    .list-no-data{
        min-height: 250px;
    }
  }
</style>
<script>

  export default {
    name: "NoData",
    props:{
        title:{
            type:String,
            required:true
        }
    },
    data() {
      return {

      };
    },
    mounted (){

    },
    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/NoData.vue